<div class="flex h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-start justify-between bg-primary-50 px-6 dark:bg-primary-900/10"
    [ngClass]="shortScreen ? 'py-2' : 'py-4'">
    <div>
      <h2 class="text-xl font-bold">{{ title }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- body -->
  <div class="min-h-0 flex-1 overflow-auto px-6" [ngClass]="shortScreen ? 'py-3' : 'py-5'">
    <!-- información general -->
    <div class="mb-2 flex items-center gap-2">
      <mat-icon class="text-primary icon-size-5" fontSet="material-icons-outlined">info</mat-icon>
      <h3 class="font-semibold">{{ 'DOCUMENT_GENERATE.ORDER_DETAIL_MODAL.GENERAL_INFO' | t }}</h3>
    </div>
    <div class="flex flex-col gap-5 rounded-xl bg-gray-50 p-5 dark:bg-transparent">
      <!-- fila 1 -->
      <div class="grid grid-cols-1 gap-x-8 gap-y-5 sm:grid-cols-2 lg:grid-cols-5">
        <div class="flex flex-col gap-1">
          <span class="text-secondary text-sm uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.DOCUMENT_NUMBER' | t }}</span>
          <span class="text-primary font-semibold">#{{ order.serial }}</span>
          <span class="text-secondary text-sm uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.ERP_NUMBER' | t }}</span>
          <span class="text-primary font-semibold">#{{ order.erpCode || '-' }}</span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-secondary text-sm uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.CLIENT' | t }}</span>
          <span class="text-primary font-semibold"><span class="font-bold">{{ order.clientId }}</span> - {{
            order.clientName }}</span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-secondary text-sm uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.PAYMENT_CONDITION' | t }}</span>
          <span class="font-medium">{{ order.paymentCondition }}</span>
        </div>
        <div class="flex flex-col gap-1 lg:col-span-2">
          <span class="text-secondary text-sm uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.SHIPPING_ADDRESS' | t }}</span>
          <span class="font-medium">{{ order.address }}</span>
        </div>
      </div>
      <!-- fila 2 -->
      <div class="grid grid-cols-1 gap-x-8 gap-y-5 sm:grid-cols-2 lg:grid-cols-5">
        <div class="flex flex-col gap-1">
          <span class="text-secondary text-sm uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.DOCUMENT_CLASS' | t }}</span>
          <span class="font-medium">{{ order.className }}</span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-secondary text-sm uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.SALES_OFFICE' | t }}</span>
          <span class="font-medium">{{ order.salesOffice }}</span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-secondary text-sm uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.TERRITORY' | t }}</span>
          <span class="font-medium">{{ order.route }}</span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-secondary text-sm uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.TRIP' | t }}</span>
          <span class="font-medium">{{ order.trip ? '#' + order.trip : '-' }}</span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-secondary text-sm uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.DOCUMENT_DATE' | t }}</span>
          <span class="font-medium">{{ order.date | date:'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </div>

    <!-- notas / comentarios -->
    @if (order.comment) {
    <div class="mb-2 mt-6 flex items-center gap-2">
      <mat-icon class="text-primary icon-size-5" fontSet="material-icons-outlined">sticky_note_2</mat-icon>
      <h3 class="font-semibold">{{ 'DOCUMENT_GENERATE.ORDER_DETAIL_MODAL.DOCUMENT_NOTES' | t }}</h3>
    </div>
    <div class="whitespace-pre-line rounded-xl bg-gray-50 p-5 leading-relaxed dark:bg-transparent">
      {{ order.comment }}
    </div>
    }

    <!-- lista de productos -->
    <div class="mb-2 mt-6 flex items-center justify-between">
      <div class="flex items-center gap-2">
        <mat-icon class="text-primary icon-size-5" fontSet="material-icons-outlined">assignment</mat-icon>
        <h3 class="font-semibold">{{ 'DOCUMENT_GENERATE.ORDER_DETAIL_MODAL.PRODUCT_LIST' | t }}</h3>
      </div>
      <span class="text-secondary text-xs italic">{{ 'DOCUMENT_GENERATE.ORDER_DETAIL_MODAL.ITEMS_IN_DOCUMENT' | t: { count: order.products.length } }}</span>
    </div>
    <!-- móvil: tarjetas dentro de su propio contenedor con desplazamiento -->
    <div class="flex flex-col gap-3 md:hidden">
      @if (!readonly && order.products.length) {
      <div class="flex items-center gap-2">
        <mat-checkbox [checked]="allSelected()" [indeterminate]="someSelected()"
          (change)="toggleAll($event.checked)"></mat-checkbox>
        <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.SELECT_ALL' | t }}</span>
      </div>
      }
      <div class="max-h-[55vh] overflow-y-auto rounded-xl border p-3">
      <div class="flex flex-col gap-3">
      @for (p of order.products; track p.position) {
      <div class="flex flex-col rounded-xl border bg-card p-3"
        [class.cursor-pointer]="!readonly && !isBonusLine(p)"
        [class.border-primary]="!readonly && isSelected(p)"
        [ngClass]="{ 'bg-green-50 dark:bg-green-900/20': isBonusLine(p) }"
        (click)="!readonly && toggle(p)">
        <div class="flex items-start gap-2">
          @if (!readonly) {
          <mat-checkbox class="-ml-2" [checked]="isSelected(p)" [disabled]="isBonusLine(p)"
            (change)="toggle(p)" (click)="$event.stopPropagation()"></mat-checkbox>
          }
          <div class="flex min-w-0 flex-1 flex-col">
            <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.LINE_NUMBER' | t }} {{ p.position ?? '-' }}</span>
            <span class="inline-flex flex-wrap items-center gap-1.5 text-primary font-semibold"
              [class.italic]="isBonusLine(p)">
              @if (isBonusLine(p)) {
              <mat-icon class="icon-size-4 text-green-600 dark:text-green-400">subdirectory_arrow_right</mat-icon>
              }
              {{ p.code }}
              @if (!isBonusLine(p)) {
              <app-bom-cell [material]="p.material" />
              }
              @if (bonusChildPositions(p).length) {
              <span
                class="inline-flex h-6 w-6 items-center justify-center rounded-full bg-green-100 p-1 text-green-700 dark:bg-green-900 dark:text-green-300"
                [matTooltip]="'DOCUMENT_GENERATE.ORDER_DETAIL_MODAL.BONUS_AT_POSITION' | t: { position: bonusChildPositions(p).join(', ') }"
                matTooltipPosition="above">
                <mat-icon class="icon-size-4">redeem</mat-icon>
              </span>
              }
              @if (isBonusLine(p)) {
              <span class="rounded-full bg-green-100 px-1.5 py-0.5 text-[10px] font-semibold text-green-700 dark:bg-green-900 dark:text-green-300">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.FREE_BADGE' | t }}</span>
              }
            </span>
            <span class="text-sm uppercase">{{ p.name }}</span>
            @if (warehouseLabel(p)) {
            <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.WAREHOUSE_PREFIX' | t }} {{ warehouseLabel(p) }}</span>
            }
          </div>
          <button mat-icon-button color="primary" type="button" class="-mr-2 -mt-1 shrink-0"
            [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.ITEM_DETAIL_TOOLTIP' | t" [matBadge]="detailCount(p) || null" matBadgeColor="accent"
            matBadgeSize="small" (click)="openDetail(p); $event.stopPropagation()">
            <mat-icon class="icon-size-5">description</mat-icon>
          </button>
        </div>

        <div class="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 border-t pt-3 text-sm">
          <div class="col-span-2 flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.FIELDS.QUANTITY' | t }}</span>
            <span class="flex items-center gap-1">
              <span class="font-semibold">{{ p.quantity }}</span>
              @if (includedBonusQty(p)) {
              <span class="rounded-full bg-green-100 px-1.5 py-0.5 text-[10px] font-semibold text-green-700 dark:bg-green-900 dark:text-green-300"
                [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.BONUS_TOOLTIP' | t">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.FREE_UNITS' | t: { count: includedBonusQty(p) } }}</span>
              }
            </span>
          </div>
          <div class="col-span-2 flex items-center justify-between gap-2">
            <span class="text-secondary shrink-0">{{ 'DOCUMENT_GENERATE.COLUMNS.SALE_UOM' | t }}</span>
            <div class="flex min-w-0 flex-col items-end">
              <span class="min-w-0 truncate" [matTooltip]="unitDisplay(p)">{{ unitDisplay(p) }}</span>
              @if (altUnits(p); as alt) {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_LABEL' | t: { value: (alt.umbQty | dgNumber: 'stock') + ' ' + alt.umbCode } }}</span>
              @if (alt.umsQty != null) {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.SECONDARY_UOM_LABEL' | t: { value: (alt.umsQty | dgNumber: 'stock') + ' ' + alt.umsCode } }}</span>
              }
              @if (alt.umpQty != null) {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.PACKAGING_UOM_LABEL' | t: { value: (alt.umpQty | dgNumber: 'stock') + ' ' + alt.umpCode } }}</span>
              }
              }
            </div>
          </div>
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.FIELDS.PRICE' | t }}</span>
            <span>{{ order.currency }}&nbsp;{{ p.price | dgNumber }}</span>
          </div>
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.TOTALS.SUBTOTAL' | t }}</span>
            <span>{{ order.currency }}&nbsp;{{ rowSubtotal(p) | dgNumber }}</span>
          </div>
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">Desc.</span>
            <span>{{ order.currency }}&nbsp;{{ rowDiscount(p) | dgNumber }}</span>
          </div>
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">ISV</span>
            <span>{{ order.currency }}&nbsp;{{ rowIsv(p) | dgNumber }}</span>
          </div>
          <div class="col-span-2 flex items-center justify-between gap-2 border-t pt-2">
            <span class="text-secondary font-medium">TOTAL</span>
            <span class="text-primary text-base font-bold">{{ order.currency }}&nbsp;{{ rowTotal(p) | dgNumber }}</span>
          </div>
        </div>
      </div>
      }
      </div>
      </div>

      <!-- totales: equivalen a la fila de totales de la tabla, fuera del desplazamiento -->
      <div class="flex flex-col gap-2 rounded-xl border-2 border-primary bg-primary-50 p-3 text-sm dark:bg-primary-900/10">
        <div class="flex items-center justify-between gap-2">
          <span class="text-secondary">{{ 'DOCUMENT_GENERATE.ORDER_DETAIL_MODAL.TOTAL_QUANTITY' | t }}</span>
          <span class="font-semibold">{{ totalQuantity }}</span>
        </div>
        <div class="flex items-center justify-between gap-2">
          <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.SUBTOTAL' | t }}</span>
          <span class="font-semibold">{{ order.currency }}&nbsp;{{ totalSubtotal | dgNumber }}</span>
        </div>
        <div class="flex items-center justify-between gap-2">
          <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.DISCOUNT' | t }}</span>
          <span class="font-semibold">{{ order.currency }}&nbsp;{{ totalDiscount | dgNumber }}</span>
        </div>
        <div class="flex items-center justify-between gap-2">
          <span class="text-secondary">ISV</span>
          <span class="font-semibold">{{ order.currency }}&nbsp;{{ totalIsv | dgNumber }}</span>
        </div>
        <div class="flex items-center justify-between gap-2 border-t pt-2">
          <span class="font-bold">{{ 'DOCUMENT_GENERATE.COLUMNS.TOTAL' | t }}</span>
          <span class="text-primary text-lg font-bold">{{ order.currency }}&nbsp;{{ montoTotal | dgNumber }}</span>
        </div>
      </div>
    </div>

    <!-- desktop/tablet: tabla -->
    <div class="hidden max-h-[45vh] overflow-auto rounded-xl border md:block">
      <table class="w-full min-w-[1080px] border-collapse text-base">
        <thead class="sticky top-0 z-10 bg-gray-50 dark:bg-gray-800">
          <tr class="text-secondary text-left">
            @if (!readonly) {
            <th class="pl-4 pr-1 py-3">
              <mat-checkbox [checked]="allSelected()" [indeterminate]="someSelected()"
                (change)="toggleAll($event.checked)"></mat-checkbox>
            </th>
            }
            <th class="w-px whitespace-nowrap px-2 py-3 text-center font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.LINE_NUMBER' | t }}</th>
            <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRODUCT' | t }}</th>
            <th class="px-4 py-3 text-center font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.QUANTITY' | t }}</th>
            <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.SALE_UOM' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRICE' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.SUBTOTAL' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.DISCOUNT' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.TAX' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.TOTAL' | t }}</th>
            <th class="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          @for (p of order.products; track p.position) {
          <tr class="border-t" [class.cursor-pointer]="!readonly && !isBonusLine(p)"
            [class.bg-primary-50]="!readonly && isSelected(p)"
            [class.dark:bg-primary-900]="!readonly && isSelected(p)"
            [ngClass]="{ 'bg-green-50 dark:bg-green-900/20': isBonusLine(p) }"
            (click)="!readonly && toggle(p)">
            @if (!readonly) {
            <td class="pl-4 pr-1 py-3">
              <mat-checkbox [checked]="isSelected(p)" [disabled]="isBonusLine(p)" (change)="toggle(p)"
                (click)="$event.stopPropagation()"></mat-checkbox>
            </td>
            }
            <td class="w-px whitespace-nowrap px-2 py-3 text-center"
              [class.text-secondary]="isBonusLine(p)" [class.text-xs]="isBonusLine(p)">{{ p.position ?? '-' }}</td>
            <td class="px-4 py-3" [class.pl-8]="isBonusLine(p)">
              <div class="flex flex-col" [class.border-l-2]="isBonusLine(p)" [class.border-green-300]="isBonusLine(p)"
                [class.pl-3]="isBonusLine(p)">
                <span class="inline-flex items-center gap-1.5 text-primary font-semibold"
                  [class.italic]="isBonusLine(p)">
                  @if (isBonusLine(p)) {
                  <mat-icon class="icon-size-4 text-green-600 dark:text-green-400">subdirectory_arrow_right</mat-icon>
                  }
                  {{ p.code }}
                  @if (!isBonusLine(p)) {
                  <app-bom-cell [material]="p.material" />
                  }
                  @if (bonusChildPositions(p).length) {
                  <span
                    class="inline-flex h-6 w-6 items-center justify-center rounded-full bg-green-100 p-1 text-green-700 dark:bg-green-900 dark:text-green-300"
                    [matTooltip]="'DOCUMENT_GENERATE.ORDER_DETAIL_MODAL.BONUS_AT_POSITION' | t: { position: bonusChildPositions(p).join(', ') }"
                    matTooltipPosition="above">
                    <mat-icon class="icon-size-4">redeem</mat-icon>
                  </span>
                  }
                  @if (isBonusLine(p)) {
                  <span class="rounded-full bg-green-100 px-1.5 py-0.5 text-[10px] font-semibold text-green-700 dark:bg-green-900 dark:text-green-300">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.FREE_BADGE' | t }}</span>
                  }
                </span>
                <span class="uppercase">{{ p.name }}</span>
                @if (warehouseLabel(p)) {
                <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.WAREHOUSE_PREFIX' | t }} {{ warehouseLabel(p) }}</span>
                }
              </div>
            </td>
            <td class="px-4 py-3 text-center">
              <div class="flex flex-col items-center gap-1">
                <span>{{ p.quantity }}</span>
                @if (includedBonusQty(p)) {
                <span class="rounded-full bg-green-100 px-1.5 py-0.5 text-[10px] font-semibold text-green-700 dark:bg-green-900 dark:text-green-300"
                  [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.BONUS_TOOLTIP' | t">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.FREE_UNITS' | t: { count: includedBonusQty(p) } }}</span>
                }
              </div>
            </td>
            <td class="px-4 py-3 text-left">
              <div class="flex flex-col items-start">
                <span class="inline-block max-w-[140px] truncate align-middle" [matTooltip]="unitDisplay(p)">{{
                  unitDisplay(p) }}</span>
                @if (altUnits(p); as alt) {
                <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_LABEL' | t: { value: (alt.umbQty | dgNumber: 'stock') + ' ' + alt.umbCode } }}</span>
                @if (alt.umsQty != null) {
                <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.SECONDARY_UOM_LABEL' | t: { value: (alt.umsQty | dgNumber: 'stock') + ' ' + alt.umsCode } }}</span>
                }
                @if (alt.umpQty != null) {
                <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.PACKAGING_UOM_LABEL' | t: { value: (alt.umpQty | dgNumber: 'stock') + ' ' + alt.umpCode } }}</span>
                }
                }
              </div>
            </td>
            <td class="px-4 py-3 text-right">{{ order.currency }}&nbsp;{{ p.price | dgNumber }}</td>
            <td class="px-4 py-3 text-right">{{ order.currency }}&nbsp;{{ rowSubtotal(p) | dgNumber }}</td>
            <td class="px-4 py-3 text-right">{{ order.currency }}&nbsp;{{ rowDiscount(p) | dgNumber }}</td>
            <td class="px-4 py-3 text-right">{{ order.currency }}&nbsp;{{ rowIsv(p) | dgNumber }}</td>
            <td class="px-4 py-3 text-right font-semibold">{{ order.currency }}&nbsp;{{ rowTotal(p) | dgNumber }}</td>
            <td class="px-4 py-3 text-center">
              <button mat-icon-button color="primary" type="button" [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.ITEM_DETAIL_TOOLTIP' | t"
                [matBadge]="detailCount(p) || null" matBadgeColor="accent" matBadgeSize="small"
                (click)="openDetail(p); $event.stopPropagation()">
                <mat-icon class="icon-size-5">description</mat-icon>
              </button>
            </td>
          </tr>
          }
        </tbody>
        <tfoot class="sticky bottom-0 bg-gray-50 dark:bg-gray-800">
          <tr class="border-t-2 font-semibold">
            @if (!readonly) {
            <td class="px-4 py-3"></td>
            }
            <td class="px-4 py-3"></td>
            <td class="px-4 py-3">{{ 'DOCUMENT_GENERATE.ORDER_DETAIL_MODAL.TOTALS' | t }}</td>
            <td class="px-4 py-3 text-center">{{ totalQuantity }}</td>
            <td class="px-4 py-3"></td>
            <td class="px-4 py-3"></td>
            <td class="px-4 py-3 text-right">{{ order.currency }}&nbsp;{{ totalSubtotal | dgNumber }}</td>
            <td class="px-4 py-3 text-right">{{ order.currency }}&nbsp;{{ totalDiscount | dgNumber }}</td>
            <td class="px-4 py-3 text-right">{{ order.currency }}&nbsp;{{ totalIsv | dgNumber }}</td>
            <td class="px-4 py-3 text-right text-primary">{{ order.currency }}&nbsp;{{ montoTotal | dgNumber }}</td>
            <td class="px-4 py-3"></td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- adjuntos -->
    @if (attachments.length) {
    <div class="mb-2 mt-6 flex items-center gap-2">
      <mat-icon class="text-primary icon-size-5" fontSet="material-icons-outlined">attach_file</mat-icon>
      <h3 class="font-semibold">{{ 'DOCUMENT_GENERATE.ITEM_DETAIL_MODAL.ATTACHMENTS_SECTION' | t }}</h3>
      <span class="text-secondary text-xs italic">{{ attachments.length }} archivo(s)</span>
    </div>
    <div class="rounded-xl border">
      @for (file of attachments; track file.link) {
      <div class="flex items-center justify-between gap-3 border-b px-4 py-3 last:border-b-0">
        <div class="flex min-w-0 items-center gap-2">
          <mat-icon class="text-secondary icon-size-5" fontSet="material-icons-outlined">description</mat-icon>
          <span class="truncate text-sm" [matTooltip]="file.name || ''">{{ file.name || 'Archivo adjunto' }}</span>
        </div>
        <button mat-icon-button color="primary" type="button" matTooltip="Ver adjunto" (click)="openAttachment(file)">
          <mat-icon class="icon-size-5" fontSet="material-icons-outlined">visibility</mat-icon>
        </button>
      </div>
      }
    </div>
    }
  </div>

  <!-- footer -->
  <div
    class="flex flex-col items-start justify-between gap-3 border-t bg-gray-50 px-6 dark:bg-transparent sm:flex-row sm:items-center"
    [ngClass]="shortScreen ? 'py-2' : 'py-4'">
    @if (!readonly) {
    <span class="text-secondary text-sm"
      [innerHTML]="'DOCUMENT_GENERATE.ORDER_DETAIL_MODAL.SELECTED_COUNT' | t: { selected: selected.size, total: selectableProducts.length }"></span>
    <div class="flex gap-3">
      <button mat-stroked-button type="button" (click)="close()">{{ 'GENERAL.CLOSE' | t }}</button>
      <button mat-flat-button color="primary" type="button" [disabled]="selected.size === 0" (click)="useAsBase()">
        <mat-icon>content_copy</mat-icon>
        {{ 'DOCUMENT_GENERATE.ORDER_DETAIL_MODAL.USE_AS_BASE' | t }}
      </button>
    </div>
    } @else {
    <span></span>
    <div class="flex gap-3">
      <button mat-stroked-button type="button" (click)="close()">{{ 'GENERAL.CLOSE' | t }}</button>
      <button mat-flat-button color="primary" type="button" (click)="printDocument()">
        <mat-icon>print</mat-icon>
        {{ 'DOCUMENT_GENERATE.ORDER_DETAIL_MODAL.PRINT_DOCUMENT' | t }}
      </button>
    </div>
    }
  </div>
</div>